// extracted by mini-css-extract-plugin
export default {"loaderContainer":"ur25ke7Z9BQ5S_iI6rrw","titleContainer":"U9_ubXWOjqox5e_4ZeAX","loader":"YUEhVj913eP6E9J4kfl8"};